/**
 * Tags API service (SPINE tag generation)
 */

import apiClient from './api';
import { Product, ExperimentVersion, TagGenerationResult } from '../types';

export const tagsApi = {
  /**
   * Generate SPINE tags for multiple predictions
   */
  async generate(
    product: Product,
    experiment: ExperimentVersion,
    predictionIds: string[]
  ): Promise<TagGenerationResult[]> {
    const response = await apiClient.post<{ results: TagGenerationResult[] }>('/tags/generate', {
      product,
      experiment,
      predictionIds,
    });
    return response.data.results;
  },

  /**
   * Generate tags in bulk (alias for generate)
   */
  async generateBulk(
    product: Product,
    experiment: ExperimentVersion,
    predictionIds: string[]
  ): Promise<TagGenerationResult[]> {
    return this.generate(product, experiment, predictionIds);
  },
};
